import { of } from 'rxjs'
import { EpicRefined } from 'interfaces/middleware'
import { map, mergeMap } from 'rxjs/operators'
import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { GET_CRYPTO_CURRENCIES_MARKET_DATA_URL } from 'components/features/rewards/rewardsPane/constants/endpoints'
import { CurrenciesMetaGetMarketDataRequestAction } from 'components/features/rewards/rewardsPane/store/actions/currenciesStatistics'
import { CryptoRewardsPaneActions } from 'components/features/rewards/rewardsPane/store/actions'

export const loadCryptoCurrenciesMarketDataEpic: EpicRefined<CryptoRewardsPaneActions | AjaxCatchExtraActions> = (
  (action$, _, { get }) => action$.pipe(
    filterRequestOfType(CurrenciesMetaGetMarketDataRequestAction.type, 'request'),
    mergeMap((action) => get(GET_CRYPTO_CURRENCIES_MARKET_DATA_URL).pipe(
      map(({ response }) => action.success(response.items)),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
    ))
  )
)
